import BlogCategoryRepository from "@/core/infrastructure/repository/blog/BlogCategoryRepository"
import hasData from "@/core/domain/specification/hasData"

export default class BlogCategoryService {
    blogCategoryRepository: BlogCategoryRepository


    constructor() {
        this.blogCategoryRepository = new BlogCategoryRepository()
    }

    async process() {
        const { data, totalCount } = await this.blogCategoryRepository.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
